import React from "react";
import Sidebar from "../components/UI/Sidebar";
import Header from "../components/UI/Header"; // Import the Header

const MainLayout = ({ children }) => {
  return (
    <div className="flex flex-col md:flex-row bg-[#eff3f8] min-h-screen">
      {/* Sidebar Section */}
      <div className="h-auto shadow"> 
        <Sidebar />
      </div>

      {/* Main Content Section */}
      <div className="flex-grow flex flex-col overflow-hidden">
        {/* Header Section */}
        <div className="z-20">
          <Header />
          <div className="md:hidden block">
            <Sidebar />
          </div>
        </div>
          
        {/* Main Content */}
        <main className="flex-grow h-20 overflow-auto dark:bg-black bg-white shadow-sm">
          {children}
        </main>
      </div>
    </div>
  );
};

export default MainLayout;
